import { deleteRequest, get, post, put } from "../web.request";

export const exportKYCPFD = async (id, index) => {
    return await get(`/exportKycForm/${id}/${index}`);
}